// @flow
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import routerFunction from 'client/route.js'
import axios from 'axios'
import validateEmail from 'client/utils/validate-email'
// $FlowFixMe
export class PasswordResetForm extends Component {
  // state: {
  //   email: string
  // }

  static displayName: any = 'PasswordResetForm'

  state: any = {
    email: '',
    submitted: false,
    error: ''
  }
  // $FlowFixMe
  onSubmit: ((event: any) => Promise<void>) = async (event: SyntheticEvent) => {
    const { email, submitted } = this.state
    const router = routerFunction()
    event.preventDefault()

    if (submitted) {
      return
    }
    if (!email || !email.trim()) {
      // $FlowFixMe
      this.setState({ error: 'Email is required' })
      return
    }
    if (!validateEmail(email.trim())) {
      // $FlowFixMe
      this.setState({ error: 'Please enter a valid email address' })
      return
    }
    // $FlowFixMe
    this.setState({ submitted: true, error: '' })

    try {
      await axios.post('/api/v1/forgot-password/email', { email })
      router.navigate('/forgot-password/email-sent')
    } catch (e) {
      router.navigate('/forgot-password/email-send-error')
    }
  }
  // $FlowFixMe
  onInput: ((key: string, any) => void) = (key: string, { target: { value } }: SyntheticInputEvent) => {
    this.setState({ [key]: value, error: '' })
  }

  render (): any {
    const { submitted, error } = this.state
    return (
      <form className='login__form' onSubmit={this.onSubmit} noValidate>
        <div className='field'>
          <label className='field__label' htmlFor='email'>Email</label>
          <input
            id='email'
            className='field__input'
            type='email'
            placeholder='Email'
            disabled={submitted}
            onInput={this.onInput.bind(this, 'email')}
          />
          {error && <span className='field__error'>{error}</span>}
        </div>
        <button className='login__button' type='submit' disabled={submitted}>{submitted ? 'Please wait...' : 'Submit'}</button>
        <Link to='/' className='pw-reset-password__login'>Return to Login Page</Link>
      </form>
    )
  }
}

export default PasswordResetForm
